module.exports = __webpack_public_path__ + "static/media/location.ed7882d9.svg";